interface RadioBtnProps {
  group: string;
  checked: boolean;
  value: string;
  label: string;
  disabled?: boolean;
  setSelectedDateFilter: (value: string) => void;
}

const RadioBtn = ({
  group,
  checked,
  value,
  label,
  setSelectedDateFilter,
}: RadioBtnProps) => {
  return (
    <div
      onClick={() => setSelectedDateFilter(value)}
      className="flex w-full cursor-pointer items-center gap-4"
    >
      <input
        type="radio"
        value={value}
        checked={checked}
        onChange={() => setSelectedDateFilter(value)}
        name={group}
        className="accent-primary-700 focus:ring-4 focus:ring-primary-700"
      />

      <label className="cursor-pointer text-[0.85rem] font-semibold">
        {label}
      </label>
    </div>
  );
};

export default RadioBtn;
